import { defineStore } from 'pinia'
import { reactive } from 'vue'

export const useChatbotStore = defineStore('chatbot', () => {

  interface ChatbotContext {
    /**
     * Romanee（API 側）から発行されるチャットのセッション ID
     */
    sessionId: string,

    /**
     * チャットのログ保持用
     */
    logs: Array<ChatMessageItem>,

    /**
     * チャットボットの返答待機状態かどうか
     */
    waiting: boolean,

    /**
     * Chatbot がチャット展開状態かどうか
     */
    isOpen: boolean,

    /**
     * チャットボットの存在フラグ
     * 資料チャットボットの場合：対応資料のみ true になる
     */
    isExist: boolean,

    /**
     * チャットボットのレンダリングされてる高さ
     */
    height: number,
  }

  const context: ChatbotContext = reactive({
    sessionId: '',
    logs: [],
    waiting: false,
    isOpen: false,
    isExist: false,
    height: 0,
  })

  const openChatbot = () => {
    context.isOpen = true
  }

  const closeChatbot = () => {
    context.isOpen = false
  }

  const toggleChatbot = () => {
    context.isOpen = !context.isOpen
  }

  const setExist = (value: boolean) => {
    context.isExist = value
  }

  const setHeight = (value: number) => {
    context.height = value
  }

  const setSessionId = (value: string) => {
    context.sessionId = value
  }

  const clearSessionId = () => {
    context.sessionId = ''
  }

  const setWaiting = (waiting: boolean) => {
    context.waiting = waiting
  }

  const addLog = (value: ChatMessageItem) => {
    context.logs.push(value)
  }

  const addLogs = (value: ChatMessageItem[]) => {
    context.logs = [...value]
  }

  const removeLog = (index: number) => {
    context.logs.splice(index, 1)
  }

  const clearLogs = () => {
    context.logs.splice(0)
  }

  /**
   * 特定のメッセージ ID のメッセージを含む会話ログを削除
   */
  const removeLogByMessageId = (messageId: string) => {
    const logIndex = context.logs.findLastIndex((log: ChatMessageItem) => {
      return log.messages.some((message: { id: string }) => message.id === messageId)
    })
    if (logIndex > -1) context.logs.splice(logIndex, 1)
  }

  const clearAll = () => {
    clearSessionId()
    clearLogs()
  }

  return {
    // data
    context,

    // methods
    openChatbot,
    closeChatbot,
    toggleChatbot,
    setExist,
    setHeight,
    setSessionId,
    clearSessionId,
    setWaiting,
    addLog,
    addLogs,
    removeLog,
    clearLogs,
    removeLogByMessageId,
    clearAll,
  }
})
